import { Component, computed, inject, input, signal } from "@angular/core"
import { Image, SectionEnum } from "redlineLibs"
import { EditorContext, EditorService } from "../../editor/services/editor.service"
import { ImageEditComponent } from "./image/image-edit.component"
import { SvgEditComponent } from "./svg-edit.component"
import { VideoEditComponent } from "./video/video-edit.component"
import { Story } from "redlineLibs"
import { UiCollapseComponent } from "ui-collapse"
import { UiInheritDirective } from "ui-inherit"

@Component({
  imports: [
    ImageEditComponent,
    SvgEditComponent,
    VideoEditComponent,
    UiCollapseComponent,
    UiInheritDirective,
  ],
  standalone: true,
  template: `
    <div>
      Media:
    </div>
    <div class="column gap-0">
      <lib-ui-collapse [first]="true" [opened]="false">
        <ng-container ngProjectAs="title-left">
          Image
        </ng-container>
        <ng-container ngProjectAs="content">
          <e2e-image-edit [rowId]="imageRowId()"/>
        </ng-container>
      </lib-ui-collapse>
      <lib-ui-collapse [last]="!adminContext()" [opened]="false">
        <ng-container ngProjectAs="title-left">
          Video
        </ng-container>
        <ng-container ngProjectAs="content">
          <e2e-video-edit [rowId]="videoRowId()"/>
        </ng-container>
      </lib-ui-collapse>
      @if (adminContext()) {
        <lib-ui-collapse [last]="true">
          <ng-container ngProjectAs="title-left">
            SVG
          </ng-container>
          <ng-container ngProjectAs="content">
            <!--          @defer () {-->
            <e2e-svg-edit [rowId]="imageRowId()"/>
            <!--          }-->
          </ng-container>
        </lib-ui-collapse>
      }
    </div>

    <!--
          <div role="tablist" class="tabs tabs-lifted">
            <a
              role="tab"
              class="font-bold whitespace-nowrap"
              [class]="tabIndex() === 0 ? 'tab tab-active' : 'tab'"
              (click)="_tabIndex.set(0)"
            >
              Image
            </a>
            <div class="tab-content bg-base-100 border-base-300 rounded-box p-6">
              <e2e-image-edit [rowId]="imageRowId()"/>
            </div>
          </div>
          <div role="tablist" class="tabs tabs-lifted">
            <a
              role="tab"
              class="font-bold whitespace-nowrap"
              [class]="tabIndex() === 1 ? 'tab tab-active' : 'tab'"
              (click)="_tabIndex.set(1)"
            >
              Video
            </a>
            <div class="tab-content bg-base-100 border-base-300 rounded-box p-6">
              <e2e-video-edit [rowId]="videoRowId()"/>
            </div>
          </div>
          @if (adminContext()) {
            <div role="tablist" class="tabs tabs-lifted">
              <a
                role="tab"
                class="font-bold whitespace-nowrap"
                [class]="tabIndex() === 2 ? 'tab tab-active' : 'tab'"
                (click)="_tabIndex.set(2)"
              >
                SVG
              </a>
              <div class="tab-content bg-base-100 border-base-300 rounded-box p-6">
                @defer (when tabIndex() === 2) {
                  <e2e-svg-edit [rowId]="imageRowId()"/>
                }
              </div>
            </div>
          }
    -->
  `,
  selector: "e2e-media-editor",
})
export class MediaEditorComponent {
  private editorService = inject(EditorService)

  story = input<Story | undefined>()
  context = input<EditorContext | undefined>(undefined)

  adminContext = computed(() => this.context() === "admin")

  _tabIndex = signal<number | undefined>(undefined)
  tabIndex = computed<number>(() => {
    const tabIndex = this._tabIndex()
    return tabIndex !== undefined
      ? tabIndex
      : (this.editorService.editorContent()?.rows[this.imageRowId()] as Image)?.svgGraphics
        ? 2
        : 0
  })

  imageRowId = computed(() => {
    return this.story()?.[SectionEnum.IMAGE].rowId || ""
  })
  videoRowId = computed(() => this.story()?.[SectionEnum.VIDEO].rowId || "")

}
